export default __webpack_public_path__ + "static/media/Q3_3.95158cf8.jpg";